import { useState, useEffect } from 'react';

// Custom hook to fetch data from multiple endpoints
export const useMultiFetch = (endpoints, token = '', useToken = false) => {
    // State to hold responses and loading state
    const [responses, setResponses] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!token && useToken) return;
        const tokenAppendix = useToken ? '&token=' + token : '';
        const fetchData = async () => {
            try {
                // Map through each endpoint and fetch data
                const requests = endpoints.map(async (endpoint) => {
                    const response = await fetch(endpoint + tokenAppendix);
                    if (!response.ok) {
                        throw new Error(`HTTP error! Status: ${response.status}`, { cause: response });
                    }
                    const data = await response.json();
                    if (data.error) throw new Error('ERROR in UseMultiFetch', { cause: data.error });
                    return Promise.resolve(data);
                });

                // Wait for all requests to complete
                const responses = await Promise.all(requests);

                // Store responses in state
                setResponses(responses);
                setLoading(false);
            } catch (error) {
                setError(error);
                setLoading(false);
            }
        };

        fetchData(); // Call the async function
    }, [JSON.stringify(endpoints), token]); // Dependency array: re-run effect if endpoints change

    return { responses, loading, error };
};
